if(typeof require !== 'undefined'){
  var moment = require('moment');
  var _ = require('lodash');
  var d3 = require('d3');
  var TimelineSignPost = require('./timeline-sign-post.js');
}


// This all needs to move to a require / module style
class TimelineChart {

  constructor(el, eventData){
    this.el = el;
    this.eventData = eventData;
    this._init();
  }

  _init(){
    this._dimensions();
    this._buildCanvas();
    this._buildTimelineAxis();
    this._buildEvents();
    // this._addTooltip();
  }

  update(eventData){
    this.eventData = eventData;
    this._addEvents();
  }

  _buildCanvas(){
    this.chart = d3.select(this.el);
  }

  _buildEvents(){
    this._buildEventsContainer();
    this._addEvents();
  }

  _buildEventsContainer(){
    this.eventsContainer = this.chart.append('g')
      .classed('timeline-events', true)
      .attr('transform', `translate(0, ${this.timelinePositionY})`);
  }

  _addEvents(){
    let THIS = this;

    this.eventPoints = this.eventsContainer.selectAll('g')
      .data(this.eventData);

    // Update existing
    this.eventPoints
      .classed('updated', true)
      .attr('transform', (d) => this._positionEvent(d))
      .call(function(parent){
        THIS._updateEventCircles(parent);
      });

    // Enter new elements
    this.eventPoints
      .enter().append('g')
        .classed('timeline-event', true)
        .attr('transform', (d) => this._positionEvent(d))
      .call(function(parent){
        THIS._enterEventCircles(parent);
        THIS._enterEventSignPosts(parent);
        THIS._enterEventLabels(parent);
      });

    // Remove old
    this.eventPoints.exit().remove();
  }

  _enterEventCircles(parent){
    parent
      .append('circle')
      .attr('r', 4);
  }

  _updateEventCircles(parent){
    parent.select('circle')
      .text(d => d.signPost);
  }

  _enterEventLabels(parent){
    parent.append('text')
      .text(d => d.label)
      .classed('timeline-label', true);
  }

  _enterEventSignPosts(parent){
    // parent.call((event) => {
    new TimelineSignPost(parent).render();
    // });
  }


  _positionEvent(event){
    let scale = this._xAxisMonthScale();
    let monthCountSinceStartDate = moment(event.date).diff(this._startDate(), 'months');

    return `translate(${scale(monthCountSinceStartDate)}, 0)`;
  }

  _addTooltip(){
    this.tip = d3.tip()
      .attr('class', 'chart-tip')
      .offset([-10, 0])
      .html(function(d) {
        let html = '';
        if(d.tipTitle) html += `<h3>${d.tipTitle}</h3>`;
        if(d.tipBody) html += `<p>${d.tipBody}</p>`;
        return html;
      });

    this.chart.call(this.tip);
  }

  _buildTimelineAxis(){
    this._buildXAxisContainer();
    this._buildXAxisPoints();
  }

  _buildXAxisContainer(){
    this.timelineContainer = this.chart.append('g')
      .classed('axis axis--dotted', true)
      .attr('transform', `translate(0, ${this.timelinePositionY})`);
  }

  _buildXAxisPoints(){
    const scale = this._xAxisYearScale();

    this.timelineContainer.selectAll('circle')
        .data(_.range(0, this._countYears()))
      .enter().append('circle')
        .attr('r', 1)
        .attr('transform', (year) => {
          return `translate(${scale(year)}, 0)`;
        });
  }

  _xAxisYearScale(){
    return d3.scaleLinear()
      .domain([0, this._countYears()])
      .range([0, this.chartWidth]);
  }

  _xAxisMonthScale(){
    return d3.scaleLinear()
      .domain([0, this._countMonths()])
      .range([0, this.chartWidth]);
  }

  _countMonths(){
    return moment(this._endDate())
    .diff(this._startDate(), 'months');
  }

  _countYears(){
    return moment(this._endDate())
      .diff(this._startDate(), 'years');
  }

  _startDate(){
    const events = this._sortByDate(this.eventData);
    return events[0].date;
  }

  _endDate(){
    const events = this._sortByDate(this.eventData);
    return events[events.length-1].date;
  }

  _sortByDate(events){
    const copy = events.slice(0);
    return copy.sort((a, b) => {
      if(moment(a.date).isBefore(b.date)) return -1;
      if(moment(a.date).isAfter(b.date)) return 1;
    });
  }

  _dimensions(){
    this.chartWidth = this.el.getBoundingClientRect().width;
    this.chartHeight = this.el.getBoundingClientRect().height;
    this.timelinePositionY = this.chartHeight / 2;
  }

};





if(typeof module !== 'undefined' && module.exports){
  module.exports = TimelineChart;
}else if(typeof window !== 'undefined'){
  window.TimelineChart = TimelineChart;
}
